import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { downloadFile, fetchFiles, fetchFaldonesByCategoryAndTienda } from "../../../api/files";
import RecentCatalogs from "../../../components/recents/RecentCatalogs";
import RecentManuals from "../../../components/recents/RecentManuals";
import RecentPromotions from "../../../components/recents/RecentPromotions";
import RecentCampaigns from "../../../components/recents/RecentCampaigns";
import { toast } from "../../../helpers/smu-alerts/smu-lerts";
import { StoreContext } from "../../../store/StoreContext";
import SmuCarousel from "../../../utils/smu-carousel/SmuCarousel";
import { fetchBanners } from "../../../api/banners";
import { fetchCatalogs } from "../../../api/catalogs";
import { fetchPromotions } from "../../../api/promotions";
import {
  MANUALS_CATEGORY,
} from "../../../constants/categories";

const brand = process.env.REACT_APP_BRAND || "S10";

const Home = () => {
  const { topPromotions, topCatalogs, topManuals, topSkirts, 
          banners, setTopPromotions, setTopManuals, setTopSkirts, 
          setBanners, setTopCatalogs, setPdfForPreview } =
    useContext(StoreContext);
  const [downloading, setDownloading] = useState(null);
  const { isAdmin, loggedUser } = useContext(StoreContext);

  const [loadingPromotions, setLoadingPromotions] = useState(true);
  const [loadingSkirts, setLoadingSkirts] = useState(true);

  const download = (category, fileId) => {
    setDownloading(fileId);

    downloadFile(category, fileId)
      .then(({ data, error }) => {
        if (!!error) throw new Error(error?.message);

        const {
          url,
          document: { filename },
        } = data;

        const element = document.createElement("a");
        element.setAttribute("href", url);
        element.setAttribute("download", filename);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      })
      .finally(() => setDownloading(null));
  };

  useEffect(() => {

    const handleFetchTopPromotions = async () => {
      setTopPromotions([])
      setLoadingPromotions(true);
      const { data, error } = await fetchPromotions(brand, 333, 5);
      if (error) return;
      setTopPromotions(data || []);
      setLoadingPromotions(false);
    };

    const handleFetchTopManuals = async () => {
      const { data, error } = await fetchFiles(MANUALS_CATEGORY, 5);
      if (error) return;
      const topManuals = data?.data?.documents || [];
      setTopManuals(topManuals);
    };
  
    const handleFetchTopSkirts = async () => {
      // Get username and tienda from loggedUser (or context)
      setLoadingSkirts(true);
      setTopSkirts([]);
      if( loggedUser && loggedUser.username){
        const username = loggedUser.username;
        const tienda = isAdmin ? null : (loggedUser && loggedUser.store ? loggedUser.store[0] : -1);
        const limit = 5;
        const { data, error } = await fetchFaldonesByCategoryAndTienda(tienda, username,null, null, null, null, null, null, null, null, null, null, null, null, limit);
        if (error) return;
        const faldones = (data || [])
          .filter((faldon, idx) => idx < 5 ) //|| !faldon.DOWNLOADED)
          .map(faldon => ({
          ...faldon,
          filename: faldon.FALDON_XLSX.replace(/\.(xlsx|xls)$/i, ''),
          id: faldon.FALDON_XLSX,
          views: faldon.VIEWS,
        }));
        setTopSkirts(faldones);
        setLoadingSkirts(false);
      }else{
        setLoadingSkirts(false);
      }
    };
  
    const handleFetchBanners = async () => {
      const { data, error } = await fetchBanners();
      if (error) return;
      const banners = data?.data?.documents || [];
      setBanners(banners);
    };

    const handleFetchCatalogs = async () => {
      const { data, error } = await fetchCatalogs();
      if (error) return;
      const catalogs = data?.data?.details || [];
      setTopCatalogs(catalogs.slice(0, 5));
      if (catalogs?.length > 0) setPdfForPreview(catalogs[0]);
    };

    handleFetchTopPromotions();
    handleFetchCatalogs();
    handleFetchTopManuals();
    handleFetchTopSkirts();
    handleFetchBanners();

  }, [loggedUser])

  return (
    <Row>
      <Col col={12} className="col-7 mb-4">
        <SmuCarousel banners={banners} />
      </Col>
      <Col col={12} className="col-5 mb-4">
        <RecentPromotions promotions={topPromotions} loading={loadingPromotions} />
      </Col>
      <Col col={12} className="col-4 mb-4">
        <RecentCampaigns
          loading={loadingSkirts}
          faldones={topSkirts}
        />
      </Col>
      <Col col={12} className="col-4 mb-4">
        <RecentManuals
          manuals={topManuals}
          download={download}
          downloading={downloading}
        />
      </Col>
      <Col col={12} className="col-4 mb-4">
        <RecentCatalogs
          catalogs={topCatalogs}
          download={download}
          downloading={downloading}
        />
      </Col>
    </Row>
  );
};

export default Home;
